import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/architecture-book/page.tsx");
